// extracted by extract-css-chunks-webpack-plugin
module.exports = {"order-details-container":"OrderSummary-cc1c40892bf3851f","order-details":"OrderSummary-076403350739e281","image-container":"OrderSummary-99f71e1ecb590f4d"};